import {
  onMounted, ref, watch, computed,
} from 'vue';
import axios from 'axios';
import { dateToLocaleDateString } from '../../../libs/dates';
import { gestionarIncompatibles } from '../../../libs/checkboxes';
import { jsonToForm } from '../../../libs/forms';

export default {
  template: '#declaracion-conjunta-form-template',
  setup() {
    const agrupaciones = ref([]);
    const ejercicios = ref([]);
    // Array de objetos centro y dentro la lista de declaraciones disponibles
    const infoCentros = ref([]);

    const agrupacion = ref();
    const ejercicio = ref();
    const declaracionesSeleccionadas = ref([]);

    const cargando = ref(false);
    const root = ref();

    const puedeGenerar = computed(() => (
      declaracionesSeleccionadas.value.length > 0
    ));

    async function loadInfoConjunta() {
      const params = {
        agrupacion_id: agrupacion.value?.id,
        ejercicio: ejercicio.value,
      };
      const { data } = await axios.get('/integracion/modelo182/conjunta_info', { params });
      agrupaciones.value = data.agrupaciones;
      ejercicios.value = data.ejercicios;
      infoCentros.value = data.info_centros || [];
    }

    function reset() {
      agrupacion.value = null;
      ejercicio.value = null;
      declaracionesSeleccionadas.value = [];
      infoCentros.value = [];
    }

    onMounted(async () => {
      cargando.value = true;
      reset();

      gestionarIncompatibles(root.value);

      try {
        await loadInfoConjunta();
        if (agrupaciones.value.length) {
          agrupacion.value = agrupaciones.value[0];
        }
        if (ejercicios.value.length) {
          ejercicio.value = ejercicios.value[0];
        }
      } finally {
        cargando.value = false;
      }
    });

    const toggleDeclaracion = (declaracion, checked) => {
      if (!checked) {
        declaracionesSeleccionadas.value.splice(
          declaracionesSeleccionadas.value.indexOf(declaracion.id), 1,
        );
      } else {
        declaracionesSeleccionadas.value.push(declaracion.id);
      }
    };

    const copiarDeclaracion = (declaracion) => {
      jsonToForm(root.value, declaracion, { prefijo: 'modelo182_declaracion' });
    };

    watch(agrupacion, loadInfoConjunta);
    watch(ejercicio, loadInfoConjunta);

    return {
      root,
      agrupaciones,
      ejercicios,
      agrupacion,
      ejercicio,
      infoCentros,
      puedeGenerar,
      dateToLocaleDateString,
      toggleDeclaracion,
      copiarDeclaracion,
    };
  },
};
